export function assign(target, source) {
    const keys = Object.keys(source);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        target[key] = source[key];
    }
}

//# sourceMappingURL=assign.js.map